import { validatePostcode, validateAddress } from '../utils';

export const initialState = {
  searchPostcode: '',
  postcodeValid: false,
  searchPostcodeError: false,
  addresses: [],
  newAddress: {
    name: '',
    line_1: '',
    line_2: '',
    line_3: '',
    line_4: '',
    line_5: '',
    postcode: '',
  },
  newAddressValid: false,
  nameEmpty: false,
  loading: false,
  showManualAddressButton: false,
  postcodeErrorMessage: 'No Addresses found for postcode',
  postcodeExcluded: false,
  disableContinueButton: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_ADDRESS':
      return {
        ...state,
        newAddress: action.payload,
        nameEmpty: action.payload.name === '',
        newAddressValid: validateAddress(action.payload),
      };
    case 'SET_SEARCH_POSTCODE':
      return {
        ...state,
        searchPostcode: action.payload,
        searchPostcodeError: false,
        postcodeValid: validatePostcode(action.payload).isValid,
        ...(action.payload === '' && { addresses: [] }),
      };
    case 'CLEAR_POSTCODE_ADDRESSES':
      return {
        ...state,
        searchPostcodeError: false,
        addresses: [],
        loading: true,
        showManualAddressForm: false,
      };
    case 'SET_POSTCODE_ADDRESSES':
      return {
        ...state,
        addresses: action.payload,
        loading: false,
        showManualAddressButton: true,
        showManualAddressForm: false,
        postcodeExcluded: false,
      };
    case 'SET_POSTCODE_LOOKUP_ERROR':
      return {
        ...state,
        searchPostcodeError: true,
        loading: false,
        showManualAddressForm: !action.payload.excluded,
        postcodeErrorMessage: action.payload.errorMessage,
        postcodeExcluded: action.payload.excluded,
      };
    case 'CLEAR_ADDRESS_PANEL':
      return {
        ...state,
        searchPostcode: '',
        postcodeValid: false,
        searchPostcodeError: false,
        addresses: [],
        newAddress: {
          name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          line_4: '',
          line_5: '',
          postcode: '',
        },
        newAddressValid: false,
      };
    case 'SET_DISABLE_CONTINUE_BUTTON':
      return { ...state, disableContinueButton: action.payload };
    case 'SET_ADDRESS_FIELDS':
      return {
        ...state,
        showManualAddressForm: true,
        newAddress: {
          name: state.newAddress.name,
          line_1: action.payload.line_1,
          line_2: action.payload.line_2,
          line_3: action.payload.line_3,
          line_4: action.payload.line_4,
          line_5: action.payload.line_5,
          postcode: action.payload.postcode,
        },
        newAddressValid: validateAddress(action.payload),
      };
    case 'SET_SHOW_MANUAL_ADDRESS_FORM':
      return { ...state, showManualAddressForm: action.payload };
    case 'SET_NAME_EMPTY':
      return { ...state, nameEmpty: action.payload };
    default:
      return state;
  }
};
